export default __webpack_public_path__ + "static/media/f0rmse_en.8169bc12.png";